var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustom3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.598,
    x2: 235.921,
    xlinkHref: "#lg1",
    y1: 23.556,
    y2: 300.954
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.513,
    x2: 289.564,
    xlinkHref: "#lg1",
    y1: 172.615,
    y2: 419.451
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46700"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.816,
    x2: 216.816,
    xlinkHref: "#lg2",
    y1: 368.715,
    y2: 465.752
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.795,
    x2: 185.061,
    xlinkHref: "#lg2",
    y1: 279.853,
    y2: -14.525
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.418,
    x2: 202.818,
    y1: 79.684,
    y2: 149.429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.53,
    x2: 350.709,
    xlinkHref: "#lg2",
    y1: 409.198,
    y2: 250.159
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(0 1 1 0 -900.401 900.401)",
    gradientUnits: "userSpaceOnUse",
    x1: -696.903,
    x2: -603.437,
    y1: 1244.479,
    y2: 1337.945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e9af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc123"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m404.825 453.622h-376.017c-15.91 0-28.808-12.898-28.808-28.808v-339.628c0-15.91 12.898-28.808 28.808-28.808h61.355l81.437 10 77.756-10h155.469c15.91 0 28.808 12.898 28.808 28.808v339.628c0 15.91-12.898 28.808-28.808 28.808z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.401 453.622h-289.593c-15.91 0-28.808-12.898-28.808-28.808v-339.628c0-15.91 12.898-28.808 28.808-28.808h80.069l62.263 10 67.28-10h79.982c15.91 0 28.808 12.898 28.808 28.808v339.628c-.001 15.91-12.898 28.808-28.809 28.808z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 273.194v151.62c0 15.91 12.898 28.808 28.808 28.808h376.017c15.91 0 28.808-12.898 28.808-28.808v-151.62z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m115.328 137.705 308.616 308.616c5.931-5.277 9.689-12.944 9.689-21.507v-173.225l-195.21-195.21-60.03 34.753-68.088 40.919c-.001 3.749 5.023 5.654 5.023 5.654z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.787 56.378v75.672c0 5.086 6.15 7.634 9.746 4.037 2.23-2.23 5.845-2.23 8.074 0 7.165 7.166 18.783 7.166 25.948 0 2.23-2.23 5.844-2.23 8.074 0 7.165 7.166 18.783 7.166 25.948 0 2.23-2.23 5.845-2.23 8.074 0 7.165 7.166 18.783 7.166 25.949 0 2.23-2.23 5.845-2.23 8.074 0 3.597 3.597 9.746 1.049 9.746-4.037v-75.672z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e5959"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m158.366 345.757h-105.625c-3.325 0-6.02-2.695-6.02-6.02v-8.209c0-3.325 2.695-6.02 6.02-6.02h105.625c3.325 0 6.02 2.695 6.02 6.02v8.209c0 3.325-2.695 6.02-6.02 6.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.366 379.689h-105.625c-3.325 0-6.02-2.695-6.02-6.02v-8.209c0-3.325 2.695-6.02 6.02-6.02h105.625c3.325 0 6.02 2.695 6.02 6.02v8.209c0 3.324-2.695 6.02-6.02 6.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.733 413.62h-51.992c-3.325 0-6.02-2.695-6.02-6.02v-8.209c0-3.325 2.695-6.02 6.02-6.02h51.991c3.325 0 6.02 2.695 6.02 6.02v8.209c.001 3.325-2.695 6.02-6.019 6.02z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m433.633 424.634v-149.707h-149.707z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.389 230.289-100.186-66.123c-11.266-7.435-26.279.644-26.279 14.142v30.916h-80.972c-9.009 0-16.313 7.303-16.313 16.313v37.789c0 9.009 7.303 16.313 16.313 16.313h80.972v30.916c0 13.498 15.013 21.578 26.279 14.142l100.186-66.123c10.148-6.698 10.148-21.587 0-28.285z",
    fill: "url(#SVGID_7_)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom3);
export default __webpack_public_path__ + "static/media/custom_3.54feb280672a975b1926d01d760aa00a.svg";
export { ForwardRef as ReactComponent };